module.exports = __webpack_public_path__ + "static/media/icon-piece5-6.3e862c5c.png";